// KIVO product photography & 3D model assets.
// Premium hero/lifestyle photos uploaded by the brand + the original
// 9-bottle contact sheet for collections we don't yet have hero shots of.

export const ASSETS = {
  // Hero / lifestyle photography (Corporate Chaos collection)
  heroBlackMarble:
    'https://customer-assets.emergentagent.com/job_daily-pause-1/artifacts/elsbma4v_hf_20260603_203347_2ed10e34-e623-49f9-b2d3-2b4a3d3793c7.png',
  heroStoneGreyDesk:
    'https://customer-assets.emergentagent.com/job_daily-pause-1/artifacts/vvsxem73_hf_20260603_203134_549e2d25-0e72-436b-a242-a123e41958b3.png',
  heroNavySkyline:
    'https://customer-assets.emergentagent.com/job_daily-pause-1/artifacts/aqkoiyph_hf_20260603_203641_33bc4c85-f7a2-4b1c-be69-ea51aab82491.png',

  // Studio 3D angles (Corporate Chaos · Black) — used in the rotate-to-explore modal
  topAngleBlack:
    'https://customer-assets.emergentagent.com/job_daily-pause-1/artifacts/obw56zpc_hf_20260603_204258_a0cb1104-011d-4100-888a-b42a124be775.png',
  backAngleBlack:
    'https://customer-assets.emergentagent.com/job_daily-pause-1/artifacts/dhzj6n4u_hf_20260603_204258_ebf35f0b-789d-44c9-8a71-c36f69239df7.png',

  // Lifestyle photography per collection
  girlsClubLifestyle:
    'https://customer-assets.emergentagent.com/job_daily-pause-1/artifacts/lc218fga_hf_20260603_203744_6184778f-b0f8-4715-9fbb-e4de66e51dce.png',
  genzOfficeIndia:
    'https://customer-assets.emergentagent.com/job_daily-pause-1/artifacts/auep8th5_hf_20260603_204053_0416f4aa-6015-4da4-8b5e-f519e307ed72.png',
  sageGreenDesk:
    'https://customer-assets.emergentagent.com/job_daily-pause-1/artifacts/xfm5qtts_hf_20260603_204115_c4556c5f-2382-4a04-bbb3-a9ea7f76ca71.png',

  // Original 9-bottle contact sheet (fallback)
  contactSheet:
    'https://customer-assets.emergentagent.com/job_16c8c640-a514-4fa8-96ae-5ac9fbd4e856/artifacts/drzxgtv7_image.png',
};

// Per-collection bottle config for the modal rotate-to-explore experience.
// Frames are ordered: front → 3/4 → back → 3/4 → front (looping rotation).
export const COLLECTIONS = {
  corporate: {
    id: 'corporate',
    name: 'Corporate Chaos',
    quote: ['SIP FIRST.', 'PANIC LATER.'],
    sub: 'For meetings, deadlines, and the 4th coffee that doesn’t count.',
    bg: '#0E0E0E',
    fg: '#FAF8F4',
    accent: '#CBBBA0',
    surface: '#1A1A1A',
    cardImage: ASSETS.heroBlackMarble,
    rotation: {
      front: ASSETS.heroBlackMarble,
      back: ASSETS.backAngleBlack,
      top: ASSETS.topAngleBlack,
      hasFullRotation: true,
    },
    specs: {
      Colour: 'Matte Black',
      Capacity: '700ml · 24oz',
      Finish: 'Soft-Touch Matte',
      Material: '304 Stainless Steel',
      Lid: 'Clear Slide Lid',
      Print: 'Laser Engraved',
    },
  },
  girls: {
    id: 'girls',
    name: 'Girls Club',
    quote: ['DRINK WATER.', 'BESTIE.'],
    sub: 'Main character hydration. Soft pastels, soft routines.',
    bg: '#F4E2DA',
    fg: '#3A2A2A',
    accent: '#8C5B5B',
    surface: '#FBEFE8',
    cardImage: ASSETS.girlsClubLifestyle,
    // Lifestyle photo used as both faces (no separate back render available yet)
    rotation: {
      front: ASSETS.girlsClubLifestyle,
      back: ASSETS.girlsClubLifestyle,
      hasFullRotation: true,
    },
    specs: {
      Colour: 'Soft Pink',
      Capacity: '700ml · 24oz',
      Finish: 'Soft-Touch Matte',
      Material: '304 Stainless Steel',
      Lid: 'Clear Slide Lid',
      Print: 'Laser Engraved',
    },
  },
  genz: {
    id: 'genz',
    name: 'Gen-Z Collection',
    quote: ['OYE.', 'PAANI PEE LE.'],
    sub: 'Loud quotes, quiet luxury. Stay hydrated, beta.',
    bg: '#F1E6BD',
    fg: '#3D3417',
    accent: '#9B7E1F',
    surface: '#F8F1D2',
    cardImage: ASSETS.genzOfficeIndia,
    rotation: {
      front: ASSETS.genzOfficeIndia,
      back: ASSETS.genzOfficeIndia,
      hasFullRotation: true,
    },
    specs: {
      Colour: 'Butter Yellow',
      Capacity: '700ml · 24oz',
      Finish: 'Soft-Touch Matte',
      Material: '304 Stainless Steel',
      Lid: 'Clear Slide Lid',
      Print: 'Laser Engraved',
    },
  },
};
